<!--Carousel-->
<section class="container-fluid backgroundColor mine-shaft lighten-1 nav-border-bottom container-height position-relative pos-top-height">
	<div class="container position-relative carousel-pos ">
		<div id="carouselExampleIndicators" class="carousel slide indicators-border carousel-fade" data-ride="carousel">
			<ol class="carousel-indicators">
				<ng-container *ngFor="let img of carousel; let i = index;">
					<li data-target="#carouselExampleIndicators" data-slide-to="{{i}}" [class.active]="i==0"></li>
				</ng-container>
			</ol>
			<div class="carousel-inner fixed">
				<ng-container *ngFor="let img of carousel; let i= index">
					<div class="carousel-item" data-interval="5000" [class.active]="i==0">
						<a class="list-group-item disabled" tabindex="-1" aria-disabled="true" href="">
							<img src="https://{{apiUrl}}/api/carousel/image/{{img.file}}" class="d-block img-fluid" alt="...">
						</a>
					</div>
				</ng-container>
			</div>

			<a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
				<span class="sr-only">Previous</span>
			</a>
			<a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
				<span class="sr-only">Next</span>
			</a>
		</div>
	</div>
	<div class="container backgroundColor mine-shaft base indicators-border d-flex align-items-center position-relative top-height">
	</div>
</section>
<!--Cards-->
<section class="container-fluid backgroundColor mine-shaft base nav-border-bottom position-relative top-119 six-cards">
	<div id="row" class="container position-relative top-85">
		<div class="row">
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-7 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Alta Relojoaria</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/produtos?query=&marca=&type=alta"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-5 col-5  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/altaRelojoaria.png" alt="...">
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-7 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Relojoaria</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/produtos?query=&marca=&type=relogio"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-4 col-4  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/relojoaria.png" alt="...">
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-7 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Joalharia</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/produtos?query=&marca=&type=j1"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-5 col-5  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/joias.png" alt="...">
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-7 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Noivas</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/noivas"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-5 col-5  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/noivas.png" alt="...">
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-7 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Pratas</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/produtos?query=&marca=&type=j2"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-4 col-5  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/pratas.png" alt="...">
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-3">
				<div class="card mb-3 card-expand shadow-card">
					<div class="row no-gutters">
						<div class="col-md-6 col-7">
							<div class="card-body">
								<h2 class="card-title textColor new-orleans base font-italic">Acessórios</h2>
								<p class="card-text text-white"><br></p>
								<a class="font-decoration text-white" href="/produtos?query=&marca=&type=acess"><button class="btn btn-grad">Ver Mais</button></a>
							</div>
						</div>
						<div class="col-md-6 col-5  mx-auto my-auto">
							<img class="img-fluid pr-3" src="../../assets/images/cardFilter/acessorios.png" alt="...">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!--Special Edition-->
<section class="container-fluid bg-gradient nav-border-bottom position-relative top-119">
	<div id="row" class="container text-center pt-5 pb-5">
		<div class="row">
			<div class="col-md-6 text-center my-auto">
				<div class="mb-3">
					<div class="card-body">
						<h1 class="card-title textColor new-orleans base font-italic">{{destaque.nome}}</h1>
						<h2 class="card-subtitle mb-2 textColor harvest-gold base font-italic">{{destaque.subnome}}</h2>
						<p class="card-text text-white text-justify text-limit">{{destaque.body}}</p>
					</div>
				</div>
				<a class="font-decoration text-white" href="{{destaque.link}}" *ngIf="destaque.link != ''"><button class="btn btn-grad px-5 py-2">Ver Mais</button></a>
			</div>
			<div class="col-md-6 mt-5 mb-5">
				<img class="img-fluid img-expand img-filter" src="https://{{apiUrl}}/api/destaques/image/{{destaque.id}}/{{destaque.media.split(';')[0]}}" alt="..." *ngIf="!destaque.typeMedia">
				<div class="embed-responsive embed-responsive-16by9" *ngIf="destaque.typeMedia">
					<iframe class="embed-responsive-item" [src]="dLink" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" frameborder="0"></iframe>
				</div>
			</div>

		</div>
	</div>
</section>
<!--New Products-->
<section class="container-fluid backgroundColor mine-shaft base nav-border-bottom d-flex align-items-center position-relative top-119">
	<div class="col-md-12 no-padd">
		<div id="row" class="container pb-20 pt-5">
			<div class="row">
				<div class="col-md-12">
					<div class="bg-yellow-gradient text-shadow">
						<h1 class="py-2 m-6 mt-16 mb-16 a-font-style font-italic textColor black">Novos Produtos</h1>
					</div>
				</div>
				<div class="row text-center col-12">
					<ng-container *ngFor="let item of produtos;let i = index">
						<div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-5 card-expand" *ngIf="i < 8">
							<div class="card card-w-h shadow-card">
								<div class="">
									<img src="https://{{apiUrl}}/api/produtos/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top backgroundColor img-h white base img-fluid rounded-0" alt="...">
								</div>
								<div class="card-body list-inline">
									<h2 class="card-text text-white card-text-limit font-italic">{{get(item.marcasId)}}</h2>
									<h2 class="card-text text-white card-text-limit mt-4 font-italic h-16">{{item.nome}}</h2>
									<div class="d-flex justify-content-around  align-items-baseline position-relative -bottom-2">
										<p class="card-text list-inline-item textColor new-orleans base position-relative">Sob consulta €</p>
										<a href="/produtos/modelo?id={{item.id}}" class="btn btn-grad list-inline-item position-relative">Ver Mais</a>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="d-flex justify-content-end mt-10 -mb-10">
				<a href="/produtos" class="btn btn-yellow-grad px-16 mr-6">Ver Mais</a>
			</div>
		</div>
	</div>
</section>
<!--Brand Slide-->
<section class="container-fluid bg-gradient nav-border-bottom d-flex align-items-center position-relative top-119">
	<div class="col-md-12 no-padd">
		<div id="row" class="container">
			<div class="row">
				<div class="col-md-12">
					<div class="mt-14 bg-yellow-gradient d-flex column-center text-center justify-content-around text-shadow list-inline">
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('alta')">Alta Relojoaria</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('relogio')">Relojoaria</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('joia')">Joalharia</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('prata')">Pratas</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('noiva')">Noivas</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('acess')">Acessórios</a></h1>
						<span class="my-auto">|</span>
						<h1 class="mt-1 py-1 list-inline-item font-italic"><a class="a-font-style  text-body pointer" (click)="filter('')">Todas</a></h1>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 pt-20 pb-20">
					<app-slider [media]="mMedias" [delay]="3" [loop]="true"></app-slider>
				</div>
			</div>
		</div>
	</div>
</section>
<!--News-->
<div class="backgroundColor mine-shaft base">
	<section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119">
		<div class="col-md-12">
			<div id="row" class="container pt-5">
				<div class="row">
					<div class="col-md-12">
						<div class="bg-yellow-gradient text-shadow">
							<h1 class="py-2 m-6 mt-16  a-font-style font-italic textColor black">Notícias</h1>
						</div>
					</div>
					<div class="row col-12">
						<ng-container *ngFor="let item of noticias; let i=index">
							<div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 col-12 d-flex justify-content-center mt-3 mb-5 card-expand" *ngIf="i < 8">
								<div class="card shadow-card">
									<img src="https://{{apiUrl}}/api/news/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top backgroundColor img-h white base img-fluid rounded-0" alt="...">
									<div class="card-body d-flex flex-column">
										<p class="card-text p-font-title h2 textColor harvest-gold base card-text-limit">{{item.titulo}}</p>
										<p class="card-text text-white text-justify text-limit">{{item.body}}</p>
										<a href="/noticias/item?id={{item.id}}" class="btn btn-grad mt-auto">Ver Mais</a>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="d-flex justify-content-end mt-10 mb-10">
					<a href="/noticias" class="btn btn-yellow-grad px-16 mr-6">Ver Mais</a>
				</div>
			</div>
		</div>
	</section>
</div>